<div class="page-content">

  <div class="unAuth-text" *ngIf="!isAuthUser">
    <mat-card>
      <p>
        You are not authorized to use the Product and Safety Care eService.
        Please contact your local Product and Safety Care SME.
      </p>
    </mat-card>
  </div>
  
  <div class="cn-notification-container" *ngIf="isDisclaimerAccepted && isAuthUser">

    <mat-card class="notification-list" style="box-shadow: none;">

      <div class="notification-filter-header">

        <div class="notification-list-title">Notifications overview</div>

        <div>
          <dl-notification-search></dl-notification-search>
        </div>

        <div></div>

      </div>

      <div class="notification-filter-rows">
        <dl-notification-filter></dl-notification-filter>
      </div>

    </mat-card>

    <dl-notification-table [tableData]="notificationData" #notificationTable>
    </dl-notification-table>
  
  </div>

</div>